import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

class HamburgerMenu extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      height: undefined,
      animate: true
    };
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleHeightChange.bind(this, 'resize'));
    window.addEventListener('scroll', this.handleHeightChange.bind(this, 'scroll'));
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleHeightChange);
    window.removeEventListener('scroll', this.handleHeightChange);
  }

  UNSAFE_componentWillReceiveProps() {
    this.handleHeightChange('internal');
  }

  render() {
    const { isOpen, className, children } = this.props;
    const { height, animate } = this.state;

    let menuStyle = {};

    if (height && isOpen) { menuStyle = { height }; }

    return (
      <div
        className={cx('hamburger-menu', className, {
          open: isOpen,
          'no-anim': !animate
        })}
        style={menuStyle}
      >
        <div className="container">
          {children}
        </div>
      </div>
    );
  }

  async handleHeightChange(eventType) {
    if (!this.props.isOpen && eventType !== 'internal') { return; }

    const navbarHeight = document.getElementsByClassName('navbar')[0].offsetHeight;

    this.setState({
      height: window.innerHeight - navbarHeight,
      animate: eventType === 'internal'
    });
  }
}

HamburgerMenu.defaultProps = {};

HamburgerMenu.propTypes = {
  className: PropTypes.string,
  children: PropTypes.any,
  isOpen: PropTypes.bool
};

export default HamburgerMenu;
